export default __webpack_public_path__ + "88f51edd0ee816f2a2afb77a099fe239.svg";